import { Component } from "@angular/core";
import { UserService } from "src/app/shared/directives/user.service";
import { Router } from "@angular/router";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { UrlTrackingService } from 'src/app/core/services/utils/url-tracking-service';

@Component({
  selector: "app-mes-dossiers",
  templateUrl: "./mes-dossiers.component.html",
  styleUrls: ["./mes-dossiers.component.scss"],
})
export class MesDossiersComponent {
  MyPermissions: string[];
  private userPermission = {
    permissions: [],
  };

  constructor(
    private userService: UserService,
    private _router: Router,
    private _keycloakService: KeycloakService,
    private _urlTrackingService: UrlTrackingService
  ) {
    this.MyPermissions = _keycloakService.getAccessPermissions();
    this.userPermission.permissions = this.MyPermissions;
    this.userService.setUser(this.userPermission);
  }
}
